<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <g
        id="icon-plus"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <path
          d="M11,0 L11,9 L20,9 L20,11 L11,11 L11,20 L9,20 L9,10.999 L0,11 L0,9 L9,8.999 L9,0 L11,0 Z"
          id="Combined-Shape"
          fill="#000000"
        ></path>
      </g>
      <g
        id="icon-minus"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <rect
          id="Rectangle"
          fill="#000000"
          transform="translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000) "
          x="9"
          y="0"
          width="2"
          height="20"
        ></rect>
      </g>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "icon-toggle-plus",
};
</script>

<style scoped>
svg {
  width: 0;
  overflow: hidden;
  display: block;
}
</style>
